import React,{ useState }from 'react';
import { Button } from 'app/components';
import { CircleNotch } from '@phosphor-icons/react';
import './style';

import Questions from './questions';

const Header = (props) => {
  const {
    onSave,
    isLoading,
  } = props;

  const [showModal, setShowModal] = useState(false);

  const handleModalClose = ()=>{
    setShowModal(false);
  }

  const handleModalOpen = ()=>{
    setShowModal(true);
  }

  return (
    <header className="header-container flex items-center justify-between py-4 px-20 bg-white fixed top-0 z-30">
      <img
        className="cursor-pointer"
        src="assets/images/logo-primary.svg"
        alt="logo"
        onClick={() => onSave('/')}
      />
      <div className="flex items-center gap-3">
        <Button
          type="tertiary"
          rounded={true}
          onClick={handleModalOpen}
        >
          Questions ?
        </Button>
        <Button
          type="tertiary"
          rounded={true}
          onClick={() => onSave()}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircleNotch
              className="loader-icon"
              size={20}
              color="#B7B7B7"
            />
          ) : 'Save & Exit'}
        </Button>
      </div>

      {showModal && <Questions handleModalClose={handleModalClose}/>}
    </header>
  );
};

export default Header;
